import {router} from '../router'

const normalizePath = path => path.replace(/\/+$/, '') || path

export const goBack = () => {
	// location.key is always "default" on the first page in a session (https://github.com/remix-run/react-router/issues/9301#issuecomment-1384665557)
	const hasHistory = router.state.location.key !== 'default'
	const hasBackground = !!router.state?.location?.state?.background

	router.navigate(hasHistory || hasBackground ? -1 : '/')
}

// This is a rough mirror of `/web/src/actions/routing.js`
// so the bridge consumers can use them agnostically
export const navigateModal = async (modalLink, {overrideBackgroundPath, state = {}, replace} = {}) => {
	let currentLocation = router.state.location
	const currentBackgroundLocation = currentLocation?.state?.background
	const isCurrentlyInModal = Boolean(currentBackgroundLocation)
	const newBackgroundPath = overrideBackgroundPath ? normalizePath(overrideBackgroundPath) : null
	const currentPath = currentLocation?.pathname ? normalizePath(currentLocation.pathname) : null
	let shouldReplace = Boolean(replace && isCurrentlyInModal)

	if (newBackgroundPath) {
		if (isCurrentlyInModal) {
			await router.navigate(newBackgroundPath, {replace: true})
			currentLocation = router.state.location
		}

		if (!isCurrentlyInModal && currentPath !== newBackgroundPath) {
			await router.navigate(newBackgroundPath)
			currentLocation = router.state.location
		}

		shouldReplace = false
	}

	const background = newBackgroundPath ? currentLocation : currentBackgroundLocation || currentLocation
	const options = {replace: shouldReplace, state: {...state, background}}

	router.navigate(modalLink, options)
}
